import { deleteObject, getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export async function getBucketUrl(filepath: string) {
  const storage = getStorage();
  const gsReference = ref(storage, filepath);
  console.log(gsReference.fullPath);
  return gsReference.fullPath;
}

export async function getFileByUrl(filepath: string) {
  try {
    const storage = getStorage();
    const storageRef = ref(storage, filepath);
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (err) {
    console.error('Error fetching PDF:', err);
  }
}

export async function uploadFile(file: any, prefix: string) {
  try {
    const storage = getStorage();
    const storageRef = ref(storage, `${prefix}/${file.name}`);

    // Create a promise to handle the upload
    return new Promise<string>((resolve, reject) => {
      // 'file' comes from the Blob or File API
      uploadBytes(storageRef, file)
        .then((snapshot) => {
          console.log(`Uploaded file: ${snapshot.ref.fullPath}`);
          resolve(snapshot.ref.fullPath); // Resolve the promise with the file path
        })
        .catch((error) => {
          console.error('Error uploading file:', error);
          reject(error); // Reject the promise in case of an error
        });
    });
  } catch (error) {
    console.error('Error in try-catch block:', error);
    throw error; // Rethrow the error for error handling at a higher level if needed
  }
}

export async function deleteFile(filePath: string) {
  try {
    const storage = getStorage();
    const fileRef = ref(storage, filePath);

    // Delete the file
    await deleteObject(fileRef);
    console.log(`File deleted successfully: ${filePath}`);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error; // Rethrow the error for error handling at a higher level if needed
  }
}
